import request from "./../utils/request";


export function createForm(siteId, title, fields) {
    return request({
        url: "/forms/create-form",
        method: "post",
        headers: {
            "site-id": siteId,
        },
        data: {
            title,
            fields,
        },
    });
}

export function updateForm(siteId, formId, formData, formFieldsData) {
    return request({
        url: `/forms/update-form/${formId}`,
        method: "put",
        headers: {
            "site-id": siteId,
        },
        data: {
            formData,
            formFieldsData,
        },
    });
}

export function updateFormField(siteId, id, updateFields) {
    return request({
        url: `/forms/update-form-field/${id}`,
        method: "put",
        headers: {
            "site-id": siteId,
        },
        data: updateFields,
    });
}

export function updateFormData(siteId, formId, formData) {
    return request({
        url: `/forms/update-form-data/${formId}`,
        method: "put",
        headers: {
            "site-id": siteId,
        },
        data: formData,
    });

}

export function updateFormStatus(siteId, submissionId, newStatus) {
    return request({
        url: `/forms/update-form-status/${submissionId}`,
        method: "put",
        headers: {
            "site-id": siteId,
        },
        data: {
            newStatus,
        },
    });
}

export function deleteForm(siteId, formId) {
    return request({
        url: `/forms/delete-form/${formId}`,
        method: "delete",
        headers: {
            "site-id": siteId,
        },
    });
}

export function deleteFormField(siteId, fieldId) {
    return request({
        url: `/forms/delete-form-field/${fieldId}`,
        method: "delete",
        headers: {
            "site-id": siteId,
        },
    });
}

export function getListForm(siteId) {
    return request({
        url: "/forms/list-form",
        method: "get",
        headers: {
            "site-id": siteId,
        },
    });
}

export function getForm(siteId, formId) {
    return request({
        url: `/forms/get-form/${formId}`,
        method: "get",
        headers: {
            "site-id": siteId,
        },
    });
}

export function getFormAnswers(siteId, formId) {
    return request({
        url: `/forms/get-form-answers/${formId}`,
        method: "get",
        headers: {
            "site-id": siteId,
        },
    });
}

export function getFormAnswerTotal(siteId, formId) {
    return request({
        url: `/forms/get-form-answer-total/${formId}`,
        method: "get",
        headers: {
            "site-id": siteId,
        },
    });
}

